import { FlowExecutionRepository } from '@domain/flow-execution/repositories/flow-execution.repository';
import { FlowExecutionRepositoryService } from '../repositories/flow-execution.service';

export const FlowExecutionProvider = [
  {
    provide: FlowExecutionRepository,
    useClass: FlowExecutionRepositoryService,
  },
];
